import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { FormNumber, Selectize, FormSelect } from '~/components/FormControl';
// import AdventureFormStartEffect from './AdventureFormStartEffect';
import { FormCombo } from '~/components/FormControl';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import isEmpty from 'lodash/isEmpty';

function BasicDetail() {
    const { cardMetaData } = useFormTab();

    const { effects, conditions, prompts, adventureActiveTimings, powers } = cardMetaData;

    return (
        <>
            {!isEmpty(cardMetaData) && (
                <>
                    <Form.Row>
                        <FormNumber
                            name="basicDetail.modifiedDv1Value"
                            isNegativeAllowed
                            tooltip="DV amount to change for the first DV changed effect, i.e increase or decrease DV."
                        />
                        <FormNumber
                            name="basicDetail.modifiedDv2Value"
                            isNegativeAllowed
                            tooltip="DV amount to change for the second DV changed effect, i.e increase or decrease DV."
                        />
                        <FormNumber
                            name="basicDetail.attackModifiedValue"
                            isNegativeAllowed
                            tooltip="Additional strike given to player. Ex: Set Damage Changed."
                        />
                        <FormNumber
                            name="basicDetail.defenseModifiedValue"
                            isNegativeAllowed
                            tooltip="Additional defense given to player. Ex: Set Defense Changed."
                        />
                        <FormNumber
                            name="basicDetail.fixedDvValue"
                            tooltip="DV amount given to player."
                        />
                        <FormNumber
                            name="basicDetail.maxDvValue"
                            tooltip="Maximum DV player eligible to have after effect. Ex: Set Max DV."
                        />
                        <FormNumber
                            name="basicDetail.damageValue"
                            tooltip="Damage inflicted to player. Ex: Do Fixed Damage Player."
                        />
                        <FormNumber
                            name="basicDetail.healedValue"
                            tooltip="HP amount that card offers to heal player.Ex: Heal Player HP."
                        />
                        <FormNumber
                            name="basicDetail.hpValue"
                            tooltip="HP amount set to player. Ex: Set Player HP."
                        />
                        <FormNumber
                            name="basicDetail.blockModifiedValue"
                            tooltip="Modified block value given for player after effect finishes. Ex: Reduce Block."
                        />
                        <Selectize
                            as={Col}
                            sm="4"
                            name="basicDetail.duelEffects"
                            options={[...effects, ...conditions] || []}
                            tooltip="Effects that will run only during duels."
                        />
                        <FormNumber
                            name="basicDetail.numberOfCardsToMoveValue"
                            tooltip="Number of cards to move during a prompt, i.e moving cards from Discard pile to hand."
                            label="No. Of Cards To Move"
                        />
                        <FormNumber
                            name="basicDetail.hitValue"
                            tooltip="Number of times the player will attack. Ex: Double Tap."
                        />
                        <FormNumber
                            name="basicDetail.penaltyDvValue"
                            tooltip="Penalty DV incurred on player after effect. Ex: Overshield."
                        />
                        <FormNumber
                            name="basicDetail.pointToStealValue"
                            tooltip="Points to steal from opponent player. Ex: Avarice"
                        />
                        <FormSelect
                            name="basicDetail.powerToRefresh"
                            options={[...powers] || []}
                            sm={4}
                            tooltip="Points to steal from opponent's player. Ex: Avarice."
                        />
                    </Form.Row>
                    <Form.Row>
                        <FormNumber
                            name="basicDetail.persistentDvValue"
                            tooltip="To set persistent DV value for player."
                            sm={2}
                        />
                        <FormNumber
                            name="basicDetail.persistentStrikeValue"
                            tooltip="To set persistent strike value for player."
                            sm={2}
                        />
                        <FormNumber
                            name="basicDetail.persistentBlockValue"
                            tooltip="To set persistent block value for player."
                            sm={2}
                        />
                    </Form.Row>
                    <AdventureStartEffect
                        name="basicDetail.startEffects"
                        activeTimingOptions={adventureActiveTimings || []}
                        effectOptions={[...effects, ...conditions, ...prompts] || []}
                        tooltip="Effects the card will have when activated."
                    />
                </>
            )}
        </>
    );
}

const withFormCombo = (FormCombo) => {
    // eslint-disable-next-line react/prop-types
    const BaseFormCombo = ({ name, activeTimingOptions, effectOptions, tooltip }) => {
        const renderFunc = (index, defaultValue1, defaultValue2) => {
            return (
                <Form.Row>
                    <FormSelect
                        name={`${[name]}.${index}.activeTiming`}
                        label="Active Timing"
                        options={activeTimingOptions}
                        defaultValue={defaultValue1}
                        sm={6}
                    />
                    <Selectize
                        name={`${[name]}.${index}.effects`}
                        label={'Effects'}
                        options={effectOptions}
                        default={defaultValue2}
                        sm={6}
                    />
                </Form.Row>
            );
        };

        return (
            <FormCombo
                sm={6}
                name={name}
                headerClass="bg-info"
                renderFunc={renderFunc}
                options={activeTimingOptions}
                title="Start Effect"
                valueObj={{
                    activeTiming: '',
                    effects: '',
                }}
                tooltip={tooltip}
            ></FormCombo>
        );
    };

    return BaseFormCombo;
};

const AdventureStartEffect = withFormCombo(FormCombo);

export default BasicDetail;
